export default __webpack_public_path__ + "static/media/Gyre of the Riftcaller.994449bf.jpg";